import React from 'react';
import { useDropzone } from 'react-dropzone';
import './FileDrangAndDrop.scss';
import uploadIcon from '../../../assets/images/atom/icon-FileDragAndDrop-upload.png';
import reUploadIcon from '../../../assets/images/atom/icon-FileDragAndDrop-re-upload.png';
import deleteIcon from '../../../assets/images/atom/icon-FileDragAndDrop-delete.png';
import imageIcon from '../../../assets/images/Icon_upload_image_preview.png';
import imageBlueIcon from '../../../assets/images/Icon_upload_image_preview_blue.png';
import toast from 'react-hot-toast';
import { parseDataSizeToBytes } from '../../../../utils/convert.utils';

const defaultDropzoneStyle = {
  display: 'flex',
  width: '100%',
  height: 50,
  border: '1px dashed #B7BABE',
  borderRadius: 8,
  backgroundColor: '#FAFBFF',
  cursor: 'pointer',
};

const batchDropzoneStyle = {
  display: 'flex',
  width: '100%',
  height: '210px',
  border: '1px dashed #D8D8D8',
  borderRadius: 8,
  cursor: 'pointer',
};

const FileDragAndDrop = (props) => {
  const {
    file,
    setFile,
    maxFile = 1,
    allowExtension,
    accept,
    placeholder = 'Upload File',
    maxFileSize = 10485760, // 10MB
    label,
    disabled = false,
    type = 'default',
  } = props || {};
  // MB 단위, 소수점 1자리까지
  const totalSize = Array.isArray(file)
    ? file.reduce((acc, cur) => {
        return acc + cur.size;
      }, 0)
    : 0;
  const { value: byteSize, unit } = parseDataSizeToBytes(totalSize);
  const checkAllowedExtension = (file, allowExtension) => {
    if (!allowExtension || !file || (maxFile > 1 && file.length <= 0)) {
      return true;
    }
    return allowExtension.find((el) => el === file.name.slice(-el.length));
  };
  const onDrop = (acceptedFiles, fileRejections) => {
    if (fileRejections.length > 0) {
      fileRejections.forEach((file) => {
        file.errors.forEach((error) => {
          if (error.code === 'file-too-large') {
            toast.error(`"${file.file?.name}" is too large`);
          } else if (error.code === 'too-many-files') {
            toast.error('Too many files');
          } else if (error.code === 'file-invalid-type') {
            toast.error('Invalid File type');
          }
        });
      });
      return;
    }
    if (maxFile === 1) {
      if (checkAllowedExtension(acceptedFiles[0], allowExtension)) {
        setFile(acceptedFiles[0]);
      } else {
        toast.error('Invalid File type');
      }
    } else {
      setFile(acceptedFiles);
    }
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept,
    onDrop,
    maxFiles: maxFile,
    maxSize: maxFileSize,
    disabled,
  });
  if (type === 'batch') {
    return (
      <div className={`file-drag-and-drop batch${disabled ? ' disabled' : ''}${file.length > 0 ? ' has-file' : ''}`}>
        <div {...getRootProps({ className: 'dropzone', style: batchDropzoneStyle })}>
          <input {...getInputProps()} />
          <div className="upload-filed">
            {<img className="upload-file-icon" src={file.length > 0 ? imageBlueIcon : imageIcon} alt="upload" />}
            {isDragActive && <span className="upload-file-label drag-over">Drag over here to upload file</span>}
            {file.length > 0 && (
              <>
                <div
                  className="upload-file-label-wrapper"
                  onClick={(e) => {
                    e.stopPropagation();
                    setFile([]);
                  }}
                >
                  <span className="upload-file-label file">{file.length} files</span>
                  {totalSize && (
                    <span className="upload-file-label file">
                      {byteSize} {unit}
                    </span>
                  )}
                  <img className="delete-uploaded-file-btn" src={deleteIcon} alt="x" />
                </div>
                {/*{label ?? <span className="upload-file-label file">{label}</span>}*/}
                <span className="upload-file-description file">{'Upload new media files\n(Image File Only / Max 10MB each)'}</span>
              </>
            )}
            {!isDragActive && file.length <= 0 && <span className="upload-file-label">{placeholder}</span>}
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className={`file-drag-and-drop${disabled ? ' disabled' : ''}`}>
      <div {...getRootProps({ className: 'dropzone', style: defaultDropzoneStyle })}>
        <input {...getInputProps()} />
        <div className="upload-filed">
          {<img className="upload-file-icon" src={file ? reUploadIcon : uploadIcon} alt="upload" />}
          {isDragActive && <span className="upload-file-label drag-over">Drag over here to upload file</span>}
          {file && (
            <>
              <span className="upload-file-label file">{label ?? file.name ?? ''}</span>
              {/*{label ?? <span className="upload-file-label file">{label}</span>}*/}
              <img
                className="delete-uploaded-file-btn"
                src={deleteIcon}
                alt="x"
                onClick={(e) => {
                  e.stopPropagation();
                  setFile(null);
                }}
              />
            </>
          )}
          {!isDragActive && !file && <span className="upload-file-label">{placeholder}</span>}
        </div>
      </div>
    </div>
  );
};

export default FileDragAndDrop;
